"use client";

import { FC } from "react";
import { AUTO_POST } from "./autoPostName";

// The landing's scheduling demo: 2 s, 332 KB, silent, cached for a year.
export const AUTO_POST_INFO_VIDEO = "https://assets.klap.app/web-assets/landing/klap-demo-schedule.mp4";
// What the subtitle leaves open: where the posts show up, when, and that
// they stay editable (a manually rescheduled post is the user's; a deleted one is never
// re-booked: auto_publish_plan.ts).
export const AUTO_POST_INFO_TEXT = "Your shorts are automatically scheduled at your posting times, including any added later. Edit or remove any post before it goes out.";
/** The tile's info tooltip: wider than a text tooltip, 6px around the video (the base `!px-2.5` must be overridden by side). */
export const AUTO_POST_INFO_TOOLTIP_CLASS = "!w-[280px] !max-w-[280px] !px-1.5 !py-1.5";

/**
 * What Auto post does, as the tile's "i": a silent loop, then one line.
 * The tooltip mounts on hover, so the clip starts from its first frame each time.
 */
const AutoPostInfo: FC = () => (
  <span className="flex flex-col gap-1.5">
    <video
      src={AUTO_POST_INFO_VIDEO}
      className="aspect-video w-full rounded-md bg-slate-800 object-cover"
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      aria-hidden
      aria-label={AUTO_POST}
    />
    <span className="px-0.5">{AUTO_POST_INFO_TEXT}</span>
  </span>
);

export default AutoPostInfo;
